import React from "react";
import {Route} from "react-router-dom";
import {ADD_INSTRUMENT_ROUTE} from "../../utils/constants/RoutesConstants";
import AddInstrumentContainer from "../../pages/commons/addInstrument";

const CommonRoutes = () => {
    return (
        <React.Fragment>
            <Route path={ADD_INSTRUMENT_ROUTE} component={AddInstrumentContainer}/>
        </React.Fragment>
    );
};

export default CommonRoutes;